import { useEffect, useState } from 'react';
import './Section.scss';
import './responsiveSection.scss';
import axios from 'axios';
import Section2 from './Section2';
import Section3 from './Section3';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import JsonData from '../../json';

const devEnv = process.env.NODE_ENV !== "production";
const { REACT_APP_DEV_URL, REACT_APP_PROD_URL } = process.env;
let url = "http://localhost:5002";

const Section = (props) => {
    const navigate = useNavigate();
    let [section1Image, setSection1Image] = useState([]);
    let [section2Image, setSection2Image] = useState([]);
    let [loading, setLoading] = useState(false);

    console.log('JsonData', JsonData["first-section"]);

    useEffect(() => {
        //ajax call
        setLoading(true);
        setSection1Image(JsonData["first-section"].slice(0, 4));
        setSection2Image(JsonData["first-section"].slice(4, 8));
        setLoading(false);
    }, []);

    let renderPage = (id) => {
        navigate(`/product/${id}`, {
            state: { id: id, }
        });
    };

    return (
        <>

            {!loading ?
                <div>
                    {/* background image */}
                    <div>
                        <img className="background_image" src="https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2021/X-site/SingleTitle/TheTerminalList/3000x1200_Hero-Tall_NP._CB634276799_.jpg" alt="background-image" />
                    </div>

                    {/* first section */}
                    <div className="section1_grid">

                        {/* div 1 */}
                        <div className="section1_div1">
                            <h1>Pick up where you left off</h1>
                            <div className="section1_div1_grid">
                                {section1Image.map((data) => (
                                    <div className="section1_div1_grid_inner" key={data.id} onClick={() => { renderPage(data.id) }}>
                                        <img className="section1_div1_grid_image" src={data.image} alt={data.name} />
                                        <span>{data.name}</span>
                                    </div>
                                ))}
                            </div>
                            {/* <div className="url-parent">
                        <span className="url">View your browsing history</span>
                    </div> */}
                        </div>

                        {/* div 2 */}
                        <div className="section1_div1">
                            <h1>Amazon | Stationery is addictive</h1>
                            <div className="section1_div1_grid">
                                {section2Image.map((data) => (
                                    <div className="section1_div1_grid_inner" key={data.id} onClick={() => { renderPage(data.id) }}>
                                        <img className="section1_div1_grid_image" src={data.image} alt={data.name} />
                                        <span>{data.name}</span>
                                    </div>
                                ))}
                            </div>
                            {/* <div className="url-parent">
                        <span className="url">View your browsing history</span>
                    </div> */}
                        </div>

                        {/* div 3 */}
                        <div className="section1_div3">
                            <h1>Sell on Amazon with 50% off on Selling Fee</h1>
                            <img className="section1_div3_image" src="https://thumbs.dreamstime.com/b/customer-making-purchase-local-meat-shop-helpful-shopkeeper-wearing-apron-packs-fresh-sausage-store-isolated-165120980.jpg" alt="iphon13-image" />
                        </div>

                        {/* div 4 */}
                        <div className="section1_div4">
                            <img className="section1_div4_image" src="https://res.cloudinary.com/jerrick/image/upload/f_jpg,q_auto,w_720/5fed8e0d7c6942001cf64e93.png" alt="laptop-image" />
                        </div>

                    </div>

                    {/* second section */}
                    <Section2 />

                    {/* third section */}
                    <Section3 />

                </div> :
                <Loader />}
        </>
    )
}

export default Section;